<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import EventInboxList from './EventInboxList.vue';

const route = useRoute();

const selectedEventId = computed(() => route.params.eventId || null);
</script>

<template>
  <section class="flex w-full h-full min-w-0">
    <EventInboxList
      class="flex-shrink-0"
      :class="Boolean(selectedEventId) ? 'hidden xl:flex' : 'flex'"
      :selected-event-id="selectedEventId"
    />
    <div class="flex flex-1 min-w-0 h-full">
      <router-view />
    </div>
  </section>
</template>
